const LANDING_MEDIA_KIND_KEY = 'landing_media_kind';

export type LandingMediaKind = 'audio' | 'video';

export const saveLandingMediaKind = (kind: LandingMediaKind): void => {
  sessionStorage.setItem(LANDING_MEDIA_KIND_KEY, kind);
};

export const peekLandingMediaKind = (): LandingMediaKind | null => {
  const value = sessionStorage.getItem(LANDING_MEDIA_KIND_KEY);
  return value === 'audio' || value === 'video' ? value : null;
};

export const isLandingAudio = (): boolean => peekLandingMediaKind() === 'audio';

export const clearLandingMediaKind = (): void => {
  sessionStorage.removeItem(LANDING_MEDIA_KIND_KEY);
};
